import { render, staticRenderFns } from "./Freja.vue?vue&type=template&id=4f2a36d7&"
import script from "./Freja.vue?vue&type=script&lang=js&"
export * from "./Freja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports